import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@chakra-ui/react';
import { MdPauseCircle, MdPlayCircle } from 'react-icons/md';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

function ToggleVideoButton({ onClick = () => {}, ...props }) {
  const { tt } = useUiComponentsInternationalContext();
  const [isPlaying, setIsPlaying] = useState(true);

  const Icon = isPlaying ? MdPauseCircle : MdPlayCircle;

  return (
    <IconButton
      aria-label={
        isPlaying
          ? tt(s => s.toggleVideoButtonComponent.pauseLabel)
          : tt(s => s.toggleVideoButtonComponent.playLabel)
      }
      as="button"
      zIndex="1"
      cursor="pointer"
      opacity={0.8}
      _hover={{ opacity: 1 }}
      onClick={() => {
        setIsPlaying(!isPlaying);
        onClick(!isPlaying);
      }}
      color="white"
      bg="transparent"
      icon={<Icon size="2.5rem" />}
      {...props}
    />
  );
}

ToggleVideoButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ToggleVideoButton;
